import { resolveSrc } from "./mediaSrc.ts";
import { type FontFaceSpec } from "./types.ts";

/** Legacy Quotologies font set — used when no channel faces are passed,
 *  keeping pre-channel renders byte-identical. Exported so the Studio
 *  inputs endpoint can serve the same set via API URLs when channels
 *  are off (the browser can't staticFile() into the render bundle). */
export const LEGACY_FACES: FontFaceSpec[] = [
  { family: "AlHurra", weight: 700, src: "fonts/AlHurraTxtBold Bold.ttf" },
  { family: "Faseh", weight: 700, src: "fonts/DG Faseh-Bold.ttf" },
  { family: "Lalezar", weight: 400, src: "fonts/Lalezar-Regular.ttf" },
];

/**
 * Inject @font-face rules so Remotion can use our local Arabic fonts.
 * Rendered as a `<style>` tag inside the composition tree. The `faces`
 * prop lets each channel register its own fonts; omitted → the legacy
 * Quotologies set.
 */
/** CSS format hint for a font file. Everything shipped before 2026-09-03 was
 *  .ttf and was hard-coded 'truetype'; an .otf is CFF-based OpenType and must
 *  say so. Chrome often forgives a wrong hint, but a wrong hint is exactly the
 *  kind of thing that works locally and silently falls back in the renderer. */
function formatFor(src: string): string {
  return src.toLowerCase().endsWith(".otf") ? "opentype" : "truetype";
}

export const FontFaces = ({ faces }: { faces?: FontFaceSpec[] }): React.JSX.Element => {
  const list = faces && faces.length > 0 ? faces : LEGACY_FACES;
  const css = list
    .map(
      (f) => `@font-face{font-family:'${f.family}';font-weight:${f.weight};font-style:normal;src:url('${resolveSrc(f.src)}') format('${formatFor(f.src)}');}`,
    )
    .join("\n");
  return <style>{css}</style>;
};
